import { render, staticRenderFns } from "./AddMemberJuristicForm.vue?vue&type=template&id=4b3f1131"
import script from "./AddMemberJuristicForm.vue?vue&type=script&lang=ts"
export * from "./AddMemberJuristicForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports